import { organizationSlice } from "@/redux/organization/slice";

const actions = organizationSlice.actions;

export const {
	setCurrentPlan,
	setCompanyInfo,
	setApplicationInfoById,
	deleteApplicationInfoById,
	setOrganizationInfoFetchRequest,
	setOrganizationInfoFetchSuccess,
	setOrganizationInfoFetchFail,
	reset: resetOrganizationState,
	setOrganizationInfoFetchState,
} = actions;
